import { render } from "./VSwitch.vue?vue&type=template&id=7369ac64&scoped=true"
import script from "./VSwitch.vue?vue&type=script&lang=js"
export * from "./VSwitch.vue?vue&type=script&lang=js"

import "./VSwitch.vue?vue&type=style&index=0&id=7369ac64&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7369ac64"]])

export default __exports__